module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325705/equipment01-a28222ed86b413acb5014c88bc85cf81.png";